export const APP = 'STONE_DDP';
